import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor() { }
  
  async gettoken(): Promise<boolean> {
    try{
      const user = await Auth.currentAuthenticatedUser();
      return !!user;
    } catch{
      console.log('FAIL');
      return false;
    }
  }
  
}
